import { convertFolderName } from "routes/schedule/folder-manager/folder-management"
import { isIdInGroup } from "library/id-helpers.mjs"

export function findScheduleInStats(stats, schedule) {
    if (!stats?.stats?.schedules) return null
    return stats.stats.schedules
        .filter(Boolean)
        .find((s) => mapId(convertFolderName(s.id)) === mapId(schedule?.realId ?? schedule?.id ?? schedule))
}

function mapId(id) {
    if (!id) return id
    if (isIdInGroup(id)) {
        const parts = id.split("!")
        return [parts[0].split("~")[0], parts[1]].join("!")
    }
    return id
}
